import { WEEKDAYS_SHORT, hhmm } from '../features/portal/api';

export type Bloque = { weekday: number; start_time: string; end_time?: string | null };

/**
 * Horario de una clase en UNA línea, agrupando los días que comparten hora:
 *   Lun 17:00 · Mié 17:00      →  «Lun · Mié 17:00»
 *   Lun 17:00 · Mié 19:00      →  «Lun 17:00 · Mié 19:00»
 *
 * Carlos 15-ago-2026: en «RITMOS LATINOS +60» (lun y mié a la misma hora) la hora salía repetida.
 * Vive aquí y no en cada pantalla para que el horario se lea IGUAL en toda la app.
 * Devuelve null si la clase no tiene horario.
 */
export function horarioCorto(sch?: Bloque[] | null, separador = '  ·  ') {
  if (!sch || sch.length === 0) return null;
  const porHora = new Map<string, number[]>();
  for (const s of sch) {
    const h = hhmm(s.start_time);
    if (!porHora.has(h)) porHora.set(h, []);
    const dias = porHora.get(h)!;
    if (!dias.includes(s.weekday)) dias.push(s.weekday);   // por si el horario trae duplicados
  }
  return [...porHora.entries()]
    .sort((a, b) => a[0].localeCompare(b[0]))
    .map(([h, dias]) => `${dias.sort((a, b) => a - b).map((d) => WEEKDAYS_SHORT[d]).join(' · ')} ${h}`)
    .join(separador);
}
